import { render, staticRenderFns } from "./BillModal.vue?vue&type=template&id=465089b3&"
import script from "./BillModal.vue?vue&type=script&lang=js&"
export * from "./BillModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports